<script lang="ts">
  import { onMount } from "svelte";
  import { setHeadTitle } from "../../app/store/store-ui";
  import CreateNewAccount from "../../components/auth/create-new-account/index.svelte";
  import { storeAuthRedirectSession } from "../../app/api";

  storeAuthRedirectSession();

  onMount(() => {
    setHeadTitle("Register");
    return () => setHeadTitle("");
  })
</script>

<CreateNewAccount />
